import { createSlice } from '@reduxjs/toolkit'
import { GetMenuResponseType, MenuType } from '../../actions/types'
import {
  createMenu,
  getCurrentMenu,
  getAllMenu,
  getMenuFromCompany,
  changeMenuMainInformation,
} from '../../actions/menuAction'

export interface IMenu {
  menu: GetMenuResponseType
  menuFromCurrentCompany: GetMenuResponseType
  currentMenu: MenuType
  error: any
  isLoading: boolean
}

const initialState: IMenu = {
  menu: {
    menu: [],
    totalCount: 0,
  },
  menuFromCurrentCompany: {
    menu: [],
    totalCount: 0,
  },

  currentMenu: {
    id: 0,
    name: '',
    description: '',
  },
  isLoading: false,
  error: '',
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    resetCurrentMenu: (state) => {
      state.currentMenu = initialState.currentMenu
      state.isLoading = false
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMenu.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getAllMenu.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.menu = action.payload
    })
    builder.addCase(getAllMenu.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getMenuFromCompany.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getMenuFromCompany.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.menuFromCurrentCompany = action.payload
      state.menu = action.payload
    })
    builder.addCase(getMenuFromCompany.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getCurrentMenu.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCurrentMenu.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.currentMenu = action.payload
    })
    builder.addCase(getCurrentMenu.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(createMenu.pending, (state) => {
      state.error = ''
    })
    builder.addCase(createMenu.fulfilled, (state, action) => {
      state.error = ''
    })
    builder.addCase(createMenu.rejected, (state, action) => {
      state.error = action.payload
    })
    builder.addCase(changeMenuMainInformation.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(changeMenuMainInformation.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.currentMenu = action.payload
    })
    builder.addCase(changeMenuMainInformation.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const { resetCurrentMenu } = menuSlice.actions

export const menuReducer = menuSlice.reducer
